/**
 *  @class
 *  @function ProductSidePanelLinks
 */
if (!customElements.get('side-panel-links')) {
  class ProductSidePanelLinks extends HTMLElement {
    constructor() {
      super();
      this.links = this.querySelectorAll('button, [js-pdp-benefits-item]');
      this.drawer = document.getElementById('Product-Information-Drawer');
      this.buttons = this.drawer?.querySelector('.side-panel-content--tabs');
      this.panels = this.drawer?.querySelector('.side-panel-content--inner')?.querySelectorAll('.side-panel-content--tab-panel') || [];
      this.body = document.body;
    }
    connectedCallback() {
      if (!this.drawer || !this.buttons || !this.panels.length || !this.links.length) {
        return;
      }
      this.setupObservers();
    }
    setupObservers() {
      this.links.forEach((item, i) => {
        item.addEventListener('click', () => {
          this.body.classList.add('open-cc');
          this.buttons.toggleActiveClass(i);
          this.drawer.classList.add('active');
        });
      });
    }
  }

  customElements.define('side-panel-links', ProductSidePanelLinks);
}
